import React from 'react';
import ReactDOM from 'react-dom';
import { Utils } from 'Utils/utils';
import './assets/css/animate.css';
import './styles/abstracts/_mixins.scss';
import './index.scss';
import App from './app/App';
import * as serviceWorker from './serviceWorker';

require('./app/utils/scripts/mixpanel');
require('./app/utils/scripts/totango');

if (Utils.isProductionEnv())
  import('@sentry/react').then(Sentry => {
    Sentry.init({
      dsn:
        'https://89086f06ed7f47b4a4db2b8af0fa0639@o1303101.ingest.sentry.io/6541647',
      tracesSampleRate: 1.0,
    });
  });

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
